import styled from '@emotion/styled';
import { motion } from 'framer-motion';

import { theme } from '../../theme/theme.ts';

export function ZoneActivityPulse() {
  return (
    <S.Root viewBox="0 0 20 20">
      <S.InnerCircle cx="10" cy="10" r="4" />
      <motion.circle
        cx="10"
        cy="10"
        r="3"
        fill="none"
        stroke={theme.color.highlight}
        strokeWidth={2}
        animate={{
          r: [3, 9],
          opacity: [0.8, 0],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
      <motion.circle
        cx="10"
        cy="10"
        r="3"
        fill="none"
        stroke={theme.color.highlight}
        strokeWidth={2}
        animate={{
          r: [3, 9],
          opacity: [0.8, 0],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'linear',
          delay: 2,
        }}
      />
    </S.Root>
  );
}

class S {
  static Root = styled.svg`
    width: 20px;
    height: 20px;
  `;

  static InnerCircle = styled.circle`
    fill: ${theme.color.highlight};
  `;
}
